/*
 * @Author: jianwei.chen
 * @Date: 2024-03-22 18:46:04
 * @Description: increase position content
 */
import React, { useRef } from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { toLocale } from '@ok/blade';
import { Available } from '@ok/bot-core';
import { Alert } from '@ok/okd';
import { Create } from '@ok/trade-common';

import PopoverCuz from '_common/components/PopoverCustomize';

import AmountWithSlider from '../components/AmountWithSlider';

import styles from './index.module.less';
import store from './store';

const Content = () => {
  const {
    dispTotalAmt,
    onValueChange,
    info: { instId, instType, algoOrdType },
    min,
    max,
    marginModeByInstFamily,
    quoteCcy,
    onAvailChange,
    available,
    increaseDisabled,
  } = store;
  const amtRef = useRef(null);
  store.amtRef = amtRef;

  return (
    <div className={styles.content}>
      <Create when={increaseDisabled}>
        <Alert
          className={styles.alertContent}
          title={
            <span className={styles.alertTitle}>
              {toLocale('futuresgrid_placeorder_dialog_pos_tier_reached')}
            </span>
          }
          type={Alert.TYPE.warn}
          closable={false}
        />
      </Create>
      <AmountWithSlider
        ref={amtRef}
        className={styles.amt}
        available={available?.quoteMax}
        min={min}
        max={max}
        instId={instId}
        instType={instType}
        onValueChange={onValueChange}
        disabled={increaseDisabled}
      />
      <Available
        className={styles.avail}
        instId={instId}
        tdMode={marginModeByInstFamily}
        algoOrdType={algoOrdType}
        ccy={quoteCcy}
        instType={instType}
        onAvailChange={onAvailChange}
      />
      <div className={styles.totalAmt}>
        <PopoverCuz
          description={toLocale(
            'futuresgrid_placeorder_tooltip_added_investment_desc'
          )}
        >
          <span className={classNames(styles.amtText, 'has-tooltip')}>
            {toLocale('futuresgrid_placeorder_header_added_investment')}
          </span>
        </PopoverCuz>

        <span className={styles.totalAmtDisp}>{dispTotalAmt}</span>
      </div>
      <div className={styles.tip}>
        {toLocale('futuresgrid_placeorder_header_added_investment_desc')}
      </div>
    </div>
  );
};

export default observer(Content);
